import { render, staticRenderFns } from "./GridSeleccion.vue?vue&type=template&id=3fc99e92&"
import script from "./GridSeleccion.vue?vue&type=script&lang=ts&"
export * from "./GridSeleccion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports